/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  contentType,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (contentType) {
      payload.append('content_type', contentType);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      content_type: contentType,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    contentType,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
  }) {
    console.log(
      '🔍 [DEBUG] MessageApi.create received contentAttributes:',
      JSON.stringify(contentAttributes, null, 2)
    );

    const payload = buildCreatePayload({
      message,
      isPrivate,
      contentAttributes,
      contentType,
      echoId,
      files,
      ccEmails,
      bccEmails,
      toEmails,
      templateParams,
    });

    console.log(
      '🔍 [DEBUG] MessageApi axios payload:',
      JSON.stringify(payload, null, 2)
    );

    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: payload,
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  facebookPrivateReply(
    conversationId,
    messageId,
    cannedResponseId,
    variableValues = {}
  ) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/facebook_private_reply`,
      {
        canned_response_id: cannedResponseId,
        variable_values: variableValues,
      }
    );
  }

  instagramPrivateReply(
    conversationId,
    messageId,
    cannedResponseId,
    variableValues = {}
  ) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/instagram_private_reply`,
      {
        canned_response_id: cannedResponseId,
        variable_values: variableValues,
      }
    );
  }
}

export default new MessageApi();
